import { SipNumberUpdateRequest } from "../../model/sipNumberUpdateRequest";
import { fetchPutJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberUpdateRequest;

export async function putSipNumbers(payload: DtoType) {
  try {
    const url = apiUrls.putSipNumbers.replace("{{id}}", `${payload.id}`);
    return await fetchPutJSON(url, payload);
  } catch (err) {
    console.error("API Error - putSipNumbers:", err);
  }
}
